"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLocale = void 0;
var _i18n = require("@ori/i18n");
const useLocale = () => {
  const {
    language
  } = (0, _i18n.useTranslationsWithNamespaces)();
  const [locale] = language.split('-');
  return locale;
};
exports.useLocale = useLocale;